import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../libs/shared/core/src/helpers/internationalization/react';
import {TeammateModel} from '../../../libs/shared/core/src/models/api/teammateModel';
import {Button} from '../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {IconButton} from '../../../libs/shared/ui/src/components/buttons/iconButton';
import {useUserTheme} from '../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface TeammateCardFooterActionsProps {
  teammate: TeammateModel;
  onComposeDiscussion: () => void;
  onComposeMessage: () => void;
  onCreateEvent: () => void;
}

const StyledActionBar = styled.div`
  display: flex;
  gap: 10px;
`;

const StyledSecondaryActionsDiv = styled.div`
  display: flex;
  gap: 5px;
  // Align items on the right hand side.
  margin-left: auto;
  margin-right: 0;
`;

export const TeammateCardFooterActions: FC<TeammateCardFooterActionsProps> = (props) => {
  const {onComposeDiscussion, onComposeMessage, onCreateEvent} = props;
  const theme = useUserTheme();
  return (
    <StyledActionBar>
      <Button variant={ButtonVariantsEnum.SECONDARY} onClick={onComposeDiscussion} leftIcon="discussionSmall">
        <Trans id="teammate-card-action-discussion">New discussion</Trans>
      </Button>
      <StyledSecondaryActionsDiv>
        <IconButton
          iconName="compose"
          color={theme.greys.shade70}
          hoverColor={theme.greys.shade80}
          placement="top"
          label={<Trans id="teammate-card-footer-action-compose-message">New message</Trans>}
          onClick={onComposeMessage}
        />
        <IconButton
          iconName="newEvent"
          color={theme.greys.shade70}
          hoverColor={theme.greys.shade80}
          placement="top"
          label={<Trans id="teammate-card-footer-action-new-event">New event</Trans>}
          onClick={onCreateEvent}
        />
      </StyledSecondaryActionsDiv>
    </StyledActionBar>
  );
};
